<template>
    <button class="prompt-suggestion-button">
        <div class="prompt-suggestion-content">
            <ion-icon v-if="icon" class="prompt-icon" :name="this.icon"></ion-icon>
            <div class="prompt-details">
                <div class="prompt">{{ prompt }}</div>
            </div>
        </div>
    </button>
</template>

<script>
export default {
    props: {
        prompt: {
            type: String,
            required: true
        },
        prompt_suggestion_id: {
            type: Number,
            required: true
        },
        use_count: {
            type: Number,
            required: true
        },
        icon: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.prompt-suggestion-button {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 18px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 12px;
    align-self: stretch;
    width: 30%;
    font-size: 13pt;
    line-height: 1.2;
}

.prompt-suggestion-button:hover {
    background-color: #a1344e;
    color: white;
}
.prompt-suggestion-button:hover ion-icon {
    color: #fff;
}


.prompt-suggestion-content {
    display: flex;
    align-items: center;
}

.prompt-icon {
    margin-right: 10px;
}

.prompt-details {
    flex-grow: 1;
}

.prompt {
    text-align: left;
}

ion-icon{
    font-size: 20pt;
    margin-right: 10px;
    color: #a1344e;
    flex-shrink: 0;
}

@media (max-width: 768px) {
    .prompt-suggestion span{
        font-size: 18px;
    }
}

</style>